// Copyright (c) 2015 Steven Sojka
import throttle from 'lodash-es/throttle';

import { PreValueApplicator } from './lodash-decorators/applicators/PreValueApplicator';
import { BiTypedDecorator2, DecoratorConfig, DecoratorFactory } from './lodash-decorators/factory';

interface ThrottleOptions {
  leading?: boolean;
  trailing?: boolean;
}

export const Throttle = DecoratorFactory.createInstanceDecorator(
  new DecoratorConfig(throttle, new PreValueApplicator(), { setter: true, getter: true, optionalParams: true }),
) as BiTypedDecorator2<number, ThrottleOptions>;

export const ThrottleGetter = DecoratorFactory.createInstanceDecorator(
  new DecoratorConfig(throttle, new PreValueApplicator(), { getter: true, optionalParams: true }),
) as BiTypedDecorator2<number, ThrottleOptions>;

export const ThrottleSetter = DecoratorFactory.createInstanceDecorator(
  new DecoratorConfig(throttle, new PreValueApplicator(), { setter: true, optionalParams: true }),
) as BiTypedDecorator2<number, ThrottleOptions>;

export { Throttle as throttle };
export { ThrottleGetter as throttleGetter };
export { ThrottleSetter as throttleSetter };
export default Throttle;
